import { render, staticRenderFns } from "./GroupFind.vue?vue&type=template&id=ca1f62b6&lang=pug"
import script from "./GroupFind.vue?vue&type=script&lang=js"
export * from "./GroupFind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GroupFind: require('/home/docker/code/frontend/components/GroupFind.vue').default})
